import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import {
  BackContainer,
  CloseButton,
  Container,
  ContentContainer,
  Title,
  TitleContainer,
} from "./styles";
import GeneralDataSection, { GENERAL_SECTION_INPUTS } from "./GeneralDataSection";
import ManagerSection from "./ManagerSection";
import InitialTrailSection from "./InitialTrailSection";
import ThemeSection from "./ThemeSection";
import ActionsSection from "./ActionsSection";
import useLmsForms from "./useLmsForms";
import LoadingSection from "./LoadingSection";
import CoursesSection from "./CoursesSection";
import SwitchInput from "./components/Input/SwitchInput";

import FeaturesSection, { FEATURES_SECTION_INPUTS } from "./FeaturesSection";

export default function CreateLMSModal({
  lmsID = null,
  onSubmit = () => null,
  onClose = () => null,
}) {
  const {
    formValues,
    formErrors,
    generalError,
    isEditing,
    isLoadingSubmit,
    isLoadingData,
    handleSubmit,
    onChangeFormValue,
  } = useLmsForms({ lmsID, onClose, onSubmit });

  const restrictCourses = formValues[GENERAL_SECTION_INPUTS.RESTRICTED_COURSES] === 'yes';

  return (
    <BackContainer>
      <Container onClick={(e) => e.stopPropagation()} onSubmit={handleSubmit}>
        <TitleContainer>
          <Title>{isEditing ? "Editar painel LMS" : "Cadastro de LMS"}</Title>
          <CloseButton type="button" onClick={onClose}>
            <IoMdClose size="1.5em" />
          </CloseButton>
        </TitleContainer>
        {isLoadingData && <LoadingSection />}
        {!isLoadingData && (
          <ContentContainer>
            <GeneralDataSection
              inputs={formValues}
              errors={formErrors}
              isEditing={isEditing}
              onChangeInput={onChangeFormValue}
            />
            
            <FeaturesSection
              inputs={formValues}
              errors={formErrors}
              onChangeInput={onChangeFormValue}
            />

            <ManagerSection
              inputs={formValues}
              errors={formErrors}
              isEditing={isEditing}
              onChangeInput={onChangeFormValue}
            />
            {!isEditing && !restrictCourses && (
              <InitialTrailSection
                inputs={formValues}
                errors={formErrors}
                onChangeInput={onChangeFormValue}
              />
            )}
            {restrictCourses && (
              <CoursesSection
                inputs={formValues}
                errors={formErrors}
                onChangeInput={onChangeFormValue}
              />
            )}
            <ThemeSection
              inputs={formValues}
              errors={formErrors}
              onChangeInput={onChangeFormValue}
            />
            <ActionsSection
              isLoadingSubmit={isLoadingSubmit}
              errorMessage={generalError}
              isEditing={isEditing}
              onCancel={onClose}
            />
          </ContentContainer>
        )}
      </Container>
    </BackContainer>
  );
}